$(function () {
  Inputmask('+7 (999) 999-99-99', { showMaskOnHover: false }).mask($('#receiver_phone'));

  $('#send_sms').change(function () {
    $('#certificateSmsFields').toggle($(this).prop('checked'));
    $('#certificateSmsFields').find('input').attr('required', $(this).prop('checked'));
  });

  $('#do_send_at_time').change(function () {
    $('#certificateSendAtFields').toggle($(this).prop('checked'));
    $('#certificateSendAtFields').find('input').attr('required', $(this).prop('checked'));
    $('#certificateSendAtFields').find('input').val('');
  });

  $('input[name=where_send]').change(function () {
    if ($('#where_send-gift').prop('checked')) {
      $('.certificate__for_gift').show();
      $('#certificateSendAtFields').find('input').attr('required', $('#do_send_at_time').prop('checked'));
      $('.senderEmailWrapper').find('.main-form-helper').text('На указанный адрес будет отправлен чек');
    } else {
      $('.certificate__for_gift').hide();
      $('.certificate__for_gift').find('input').val('');
      $('.certificate__for_gift').find('textarea').val('');
      $('.certificate__for_gift').val('');
      $('#certificateSendAtFields').find('input').attr('required', false);
      $('#certificateSendAtFields').find('input').val('');
      $('.senderEmailWrapper').find('.main-form-helper').text('На указанный адрес будут отправлены сертификат и чек');
    }
  });

  $('#payment-btn').find('a').attr('href', $('.main-form-pay-method').eq(0).find('input').data('payment-link'));

  $('.main-form-pay-method').on('click', function () {
    $('#payment-btn').find('a').attr('href', $(this).find('input').data('payment-link'));
  });
});
